interface ErrorWithResponse {
  response?: {
    data?: {
      error?: unknown;
    };
  };
  message?: unknown;
}

export const extractErrorMessageString = (error: unknown): string => {
  const err = error as ErrorWithResponse;
  const responseError = err.response?.data?.error;

  let errorMessage: string | undefined;

  if (typeof responseError === 'object' && responseError !== null && 'message' in responseError) {
    const responseErrorMessage = (responseError as { message?: unknown }).message;

    if (typeof responseErrorMessage === 'string') {
      errorMessage = responseErrorMessage;
    }
  } else if (typeof responseError === 'string') {
    errorMessage = responseError;
  } else if (typeof err.message === 'string') {
    errorMessage = err.message;
  }

  if (!errorMessage) {
    return 'Unknown Error';
  }

  return errorMessage;
};

export const replaceSpaceWithUnderScore = (value: string): string => {
  const re = /\s+/g;

  return value.replace(re, '_');
};

export const properCase = (value: string): string => {
  if (value) {
    return value.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return value;
  }
};

export const parseFilename = (value: string): string | undefined => {
  const file = value.split('/');

  return file.pop();
};

export const parseApplicationId = (value: string): string | undefined => {
  const appId = value.split('/');

  return appId[1];
};
